var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Bar",class:("Bar--" + _vm.type),style:(("width:" + _vm.width))},[_c('div',{staticClass:"Bar-fill",style:(_vm.progressStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }